import { Box, Flex, Spinner } from "@chakra-ui/react"


const Loading = () => {
  return (<Box className="h-screen w-screen">
    <Flex h='full' w='full' justify='center' align='center'>
      <Spinner />
    </Flex>
  </Box>)
}

export default Loading